import { AspectRatio, MediaAsset, NotificationOverlay as NotificationOverlayProps } from 'libs/contentful/types';
import React from 'react';
import { NotificationOverlayDesktopPosition } from 'types/constants';
import Media from 'components/shared/Media/Media';
import NotificationOverlay from 'components/shared/NotificationOverlay/NotificationOverlay';
import { cn } from 'utils/styles';

export interface HeroImageProps {
  media: MediaAsset;
  aspectRatio?: AspectRatio;
  mobileMedia?: MediaAsset;
  mobileAspectRatio?: AspectRatio;
  notificationOverlay?: NotificationOverlayProps;
  notificationOverlayDesktopPosition?: NotificationOverlayDesktopPosition;
  sizes?: string;
}

export enum HeroImageLocation {
  Default = 'Default',
  Bottom = 'Bottom',
  BetweenCtaAndDisclaimer = 'Between CTA and Disclaimer',
}

const DEFAULT_HERO_IMAGE_SIZES = '(max-width: 750px) min(90vw, 450px), 600px';

export const HeroImage = ({
  notificationOverlay: overlay,
  notificationOverlayDesktopPosition,
  sizes = DEFAULT_HERO_IMAGE_SIZES,
  ...mediaProps
}: HeroImageProps) => {
  return (
    <>
      <div
        className={cn(
          'image-container max-sm:max-w-[450px] relative sm:flex sm:justify-end overflow-hidden rounded-lg',
        )}>
        <Media className="object-contain" priority sizes={sizes} {...mediaProps} />
      </div>
      {overlay && overlay.display && (
        <NotificationOverlay
          notificationOverlayDesktopPosition={notificationOverlayDesktopPosition}
          description={overlay.image.description}
          fileName={overlay.image.fileName}
          url={overlay.image.url}
        />
      )}
    </>
  );
};
